import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
const Component = props => {
  return _jsx(_Fragment, {
    children: _jsxs("svg", Object.assign({
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props, {
      children: [_jsxs("g", {
        clipPath: "url(#6q59ugp6v__clip0_14_45)",
        children: [_jsx("rect", {
          width: "20",
          height: "20",
          rx: "10",
          fill: "white"
        }), _jsxs("g", {
          clipPath: "url(#8p673zxqc__clip1_14_45)",
          children: [_jsx("path", {
            d: "M-6.5 -0.5H26.5V10H-6.5V-0.5Z",
            fill: "#0072CE"
          }), _jsx("path", {
            d: "M-6.5 6.5H26.5V17H-6.5V6.5Z",
            fill: "black"
          }), _jsx("path", {
            d: "M-6.5 13.5H26.5V20.5H-6.5V13.5Z",
            fill: "white"
          })]
        })]
      }), _jsx("rect", {
        x: "0.5",
        y: "0.5",
        width: "19",
        height: "19",
        rx: "9.5",
        stroke: "#152361"
      }), _jsxs("defs", {
        children: [_jsx("clipPath", {
          id: "6q59ugp6v__clip0_14_45",
          children: _jsx("rect", {
            width: "20",
            height: "20",
            rx: "10",
            fill: "white"
          })
        }), _jsx("clipPath", {
          id: "8p673zxqc__clip1_14_45",
          children: _jsx("rect", {
            width: "33",
            height: "21",
            fill: "white",
            transform: "translate(-6.5 -0.5)"
          })
        })]
      })]
    }))
  });
};
export default Component;
